module.exports = __webpack_public_path__ + "static/media/rockrms.dee58b36.svg";